// Logout.jsx
import React, { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/authSlice";
import indexedDbStorage from "../store/indexedDbStorage.js"; 
import { clear, keys, del, get, set } from 'idb-keyval';

import { markUnrehydrated } from "../sync/syncService";

import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text
} from "../components/layout";

export default function Logout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
  console.log("Login mounted, token:", localStorage.getItem("token"));
}, []);


// const handleLogout = async () => {
//   try {
//     // await clear();           // ← idb-keyval leeren
//     const allKeys = await keys();
//     console.log("keys before logout:", allKeys);
//     const toDelete = allKeys.filter(k => !String(k).startsWith('food-img:'));
//     console.log("deleting:", toDelete);
//     await Promise.all(toDelete.map(k => del(k)));
//     console.log("IDB cleared");
//     localStorage.clear();
//     dispatch({ type: "auth/logout" });
//     await new Promise(resolve => setTimeout(resolve, 100));
//     window.location.href = "/login";
//   } catch (error) {
//     console.error("Logout failed:", error);
//   }
// };

// const handleLogout = async () => {
//   try {
//     const allKeys = await keys();
//     console.log("all IDB keys:", allKeys);
//     const toDelete = allKeys.filter(k => !String(k).startsWith('food-img:'));
//     console.log("toDelete:", toDelete);
//     // await Promise.all(toDelete.map(k => del(k))); // ✅ already awaited — this IS waiting for IDB
//     await indexedDbStorage.clearAll()
//     console.log("done deleting");
//     localStorage.clear();
//     dispatch({ type: "auth/logout" });
//     // window.location.href = "/login"; // only runs after IDB is fully cleared
//   } catch (error) {
//     console.error("Logout failed:", error);
//     // window.location.href = "/login";
//   }
// };

// const handleLogout = async () => {
//   try {
//     localStorage.clear();
//     dispatch({ type: "auth/logout" });
    
//     // ✅ delete the entire IDB database
//     await new Promise((resolve, reject) => {
//       const req = indexedDB.deleteDatabase("keyval-store");
//       req.onsuccess = resolve;
//       req.onerror = reject;
//       req.onblocked = resolve; // continue even if blocked
//     });

//     window.location.href = "/login";
//   } catch (error) {
//     console.error("Logout failed:", error);
//     window.location.href = "/login";
//   }
// };

const handleLogout = async () => {
  try {
    markUnrehydrated();
    localStorage.clear();
    dispatch({ type: "auth/logout" });
    window.location.href = "/login";
  } catch (error) {
    console.error("Logout failed:", error);
    window.location.href = "/login";
  }
};



// const handleLogout = async () => {

//   try {
//     markUnrehydrated(); // ✅ stop all IDB writes immediately

//     // save food images
//     const allKeys = await keys();
//     const imageKeys = allKeys.filter(k => String(k).startsWith('food-img:'));
//     const imageEntries = await Promise.all(
//       imageKeys.map(async k => [k, await get(k)])
//     );

//     // wipe database
//     await new Promise((resolve, reject) => {
//       const req = indexedDB.deleteDatabase("keyval-store");
//       req.onsuccess = resolve;
//       req.onerror = reject;
//       req.onblocked = resolve;
//     });

//     // restore food images
//     await Promise.all(imageEntries.map(([k, v]) => set(k, v)));
// console.log("🔴 redirecting to /login");
//     localStorage.clear();
//     dispatch({ type: "auth/logout" });
//     window.location.href = "/login";
//   } catch (error) {
//     console.error("Logout failed:", error);
//     window.location.href = "/login";
//   }
// };

// const handleLogout = async () => {
//   try {
//     markUnrehydrated(); // ✅ block IDB writes first
    
//     const allKeys = await keys();
//     const toDelete = allKeys.filter(k => !String(k).startsWith('food-img:'));
//     await Promise.all(toDelete.map(k => del(k)));
    
//     localStorage.clear();
//     dispatch({ type: "auth/logout" });
//     window.location.href = "/login";
//   } catch (error) {
//     console.error("Logout failed:", error);
//     window.location.href = "/login";
//   }
// };

  return (
    <Screen>
         <Content>
           <Card style={{
             padding: space.sm,
             gap: space.lg
           }}
           >
            <Text variant="h1">Do you really want to logout?</Text>
            {/* <button 
              onClick={() => console.log("clicked")}
              style={{ padding: 20, fontSize: 20 }}
            >
              TEST LOGOUT
            </button> */}
            <Button  onClick={handleLogout}>Logout</Button>
            <Button 

            onClick={() => {
              if (window.history.state && window.history.state.idx > 0) {
                navigate(-1);
              } else {
                navigate('/dashboard'); // Fallback route
              }
            }}>
              Back
            </Button>
        </Card>
      </Content>
    </Screen>
  );
}
